exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-view {\n  background-color: #fff;\n  box-sizing: border-box;\n  padding: 2em 3em\n}\n\n.user-view h1 {\n  margin: 0;\n  font-size: 1.5em\n}\n\n.user-view .meta {\n  list-style-type: none;\n  padding: 0\n}\n\n.user-view .label {\n  display: inline-block;\n  min-width: 4em\n}\n\n.user-view .about {\n  margin: 1em 0\n}\n\n.user-view .links a {\n  text-decoration: underline\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user.component.css
// module id = 162
// module chunks = 1